import React from 'react'

export interface ListViewColumn {
  name: string
  label: string
  className?: string
  hidden?: boolean
}

export interface ListViewColumnsMap {
  [key: string]: ListViewColumn;
}

type Props = {
  columns: ListViewColumn[]
  children: (columns: ListViewColumnsMap) => React.ReactNode
}

const ListView = (props: Props) => {
  const columnsMap: ListViewColumnsMap = props.columns.reduce((acc: ListViewColumnsMap, column: ListViewColumn) => {
    acc[column.name] = {
      ...column
    }
    return acc
  }, {})

  return (
    <div>
      {props.children(columnsMap)}
    </div>
  )
}

export default ListView